import React, { useEffect, useState } from "react"; 
import { useConfirm } from "material-ui-confirm";
import { useSnackbar } from "notistack";
import axios from "axios";
import MapComponent from "../../../Components/Maps/MapComponent";
import { useLocation, useParams } from "react-router-dom";
import parseHtml from 'html-react-parser';
import ProgressBarComponent from "../../../Components/Forms/ProgressBarComponent";
import EnvioRotogramaViagemPopup from "./EnvioRotogramaViagemPopup";

const RotogramaViagemComponent = (props: any) => {
    const [relatorio, setRelatorio] = useState<any>({});
    const [dados, setDados] = useState<any>({});
    const [marcadores, setMarcadores] = useState<any[]>([]);
    const [coordenadas, setCoordenadas] = useState<any[]>([]);
    const [posicoes, setPosicoes] = useState<any[]>([]);
    const confirm = useConfirm();
    const { enqueueSnackbar } = useSnackbar();
    let location = useLocation();
    const { id } = useParams<{ id: string }>();
    const [loading, setLoading] = useState(true);
    const [checkboxMacroAlertaViolacao, setCheckboxMacroAlertaViolacao] = useState(false);
    const [checkboxNaoAutorizada, setCheckboxNaoAutorizada] = useState(false);
    const [checkboxAreaRisco, setCheckboxAreaRisco] = useState(false);
    const [envioRotogramaOpen, setEnvioRotogramaOpen] = useState(false);

    const estiloDesvio = {'Desvio de Rota': 'rgb(235 85 85)', 'dentro da rota': 'rgb(138 245 124)'};
    const estiloAtraso = {
        'atrasado': 'rgb(235 85 85)',
        'adiantado': 'rgb(102 132 237)',
        'tendencia de atraso': 'rgb(244 245 124)',
        'no prazo': 'rgb(138 245 124)'
    };
        
    const [usuario, setUsuario] = useState<any | null>(() => {
        const usuario = localStorage.getItem("user");
        return usuario ? JSON.parse(usuario) : [];
    });
    
    useEffect(() => {
        props.loadingCallBack(loading);
    }, [loading]);

    // useEffect(() => {
    //     (async () => {
    //     await inicializaDadosAsync();
    //     })();

    // }, []);

    useEffect(() => {
        if ((id??"") == "" || parseInt(id??"0") <= 0) {
            enqueueSnackbar('Informe uma viagem válida.', {variant: 'warning'});
            return;
        }

        setLoading(true);
        const fetchData = async () => {
            let partUrl = props.simplePage ? 'Simple' : '';
            let code = props.simplePage ? 'guid' : 'viagemId';
            let url = `rotograma${partUrl}/buscaDados?${code}=${id}&nao_autorizada=${checkboxNaoAutorizada}&area_risco=${checkboxAreaRisco}&alerta_macro=${checkboxMacroAlertaViolacao}`
            let response = await fetchDados(url);
            setDados(response);
        };
      
        fetchData();
      }, [id, checkboxNaoAutorizada, checkboxAreaRisco, checkboxMacroAlertaViolacao]);
      
      useEffect(() => {
        if (typeof dados === 'string') {
            enqueueSnackbar(dados, {variant: 'warning'});
            setLoading(false);
            return;
        } 
        
        // if (dados[0]==null) {
        //     //enqueueSnackbar("Dados invalidos", {variant: 'warning'});
        //     return;
        // }

        loadAsync();

    }, [dados]);

    async function atualizarDadosAsync() {

    }

    async function loadAsync()
    {
        try {
            if (dados == null || dados.id == null) {
                return;
            }
            
            let posicoes = [];
            
            posicoes.push({'dados': getDadosViagem(dados, true), 'latitude': dados.latitude, 'longitude': dados.longitude, 'tipo': 'Posição', 'cor': 'gold', 'type':'truck'});
            posicoes.push({'dados': getDadosOrigem(dados), 'latitude': dados.latitude_origem, 'longitude': dados.longitude_origem, 'tipo': 'Origem', 'cor': 'green', 'raio': dados.raio_origem, poligono: dados.poligono_origem});

            //posicoes.push({'nome': dados.destino, 'latitude': dados.destino_latitude, 'longitude': dados.destino_longitude, 'tipo': 'Destino', 'cor': 'blue'});
            dados.destinos?.forEach((destino:any, index:number) => {
                posicoes.push({'dados': getDestinoCard(dados, index, index==dados.destinos.length-1), 'latitude': destino.latitude, 'longitude': destino.longitude, 'tipo': 'Destino', 'cor': 'blue', 'raio': destino.raio, poligono: destino.poligono});   
            });

            dados.paradas_nao_autorizadas?.forEach((parada:any, index:number) => {
                posicoes.push({'dados': getCardGenerico(parada, "Parada não Autorizada", parada.descricao), 'latitude': parada.latitude, 'longitude': parada.longitude, 'tipo': 'NaoAutorizada', 'cor': 'red', 'raio': parada.raio});
            });

            dados.areas_risco?.forEach((area_risco:any, index:number) => {
                posicoes.push({'dados': getCardGenerico(area_risco, "Área de Risco", area_risco.descricao), 'latitude': area_risco.latitude, 'longitude': area_risco.longitude, 'tipo': 'Risco', 'cor': 'grey', 'raio': area_risco.raio});  
            });

            dados.alertas_macros?.forEach((alerta_macro:any, index:number) => {
                posicoes.push({'dados': getCardGenerico(alerta_macro, "Alerta / Macro / Violação", alerta_macro.evento), 'latitude': alerta_macro.latitude, 'longitude': alerta_macro.longitude, 'tipo': 'AlertaMacro', 'cor': 'black'});
            });

            setMarcadores(posicoes);
            
            let coordenadasInvertidas = dados.coordenadas == null || dados.coordenadas.length == 0 ? [] : dados.coordenadas.split(';')?.map((pair:any) => {
                const [lat, lng] = pair.split(',').map(Number);
                if (isNaN(lat) || isNaN(lng)) {
                    return [];
                }

                return [lng, lat];
            });

            coordenadasInvertidas = coordenadasInvertidas?.filter((coordenada:any) => 
                typeof coordenada[0] === 'number' && typeof coordenada[1] === 'number'
            );  

            setCoordenadas(coordenadasInvertidas ?? []);

            const fetchData = async () => {
                try {
                    let partUrl = props.simplePage ? 'Simple' : '';
                    let code = props.simplePage ? 'guid' : 'viagemId';
                    let response = await fetchDados(`rotograma${partUrl}/buscaPosicoes?${code}=${id}`);   
                    setPosicoes(response);
                }
                catch (err) {
                    console.error('Erro ao buscar dados:', err);
                    setLoading(false);
                }
              };
            
            fetchData();

        } catch (error) {
            console.error('Erro ao buscar dados:', error);
        }
        finally {
            setLoading(false);
        }
    }

    async function fetchDados(url: string) {
        try {
            let response: any = await axios?.get(url);
            let data = response.data;
            if (data == null || typeof data === 'string') {
                if ((data??'')!='') {
                    enqueueSnackbar(data, {variant: 'warning'});
                }

                setLoading(false);
                return [];
            } 
            
            return data;
        } catch (err) {
            console.error('Erro ao buscar dados:', err);
            enqueueSnackbar('Erro ao buscar dados', {variant: 'warning'});
            setLoading(false);
        }
    }

    function imprimirTela() 
    {
        window.print();
    }

    function getDadosViagem(dados: any, card: boolean = false) {
        return (
            <table className="tabelaMapa" style={{ width: '100%' }}>
                <tr>
                    <td colSpan={2}>
                        <strong>DADOS VIAGEM</strong>
                        {card || !dados?.enviar_rotograma || !usuario.enviar_rotograma ? '' : (
                            <>
                                <button
                                    className="btn btn-sm"
                                    style={{ float: 'right', fontSize: '9pt' }}
                                    onClick={() => setEnvioRotogramaOpen(true)}
                                >
                                    Reenviar e-mail
                                </button>
                                {/* <button
                                    className="btn btn-sm"
                                    style={{ float: 'right', fontSize: '9pt', marginRight: '5px' }}
                                    onClick={() => enviaMensagem()}
                                >
                                    Reenviar mensagem
                                </button> */}
                            </>
                        )}
                    </td>
                </tr>
                <tr>
                    <td style={{ padding: '0 5px 5px 5px' }}>
                        <table style={{ width: '100%' }}>
                            {getTableLineValue(dados.id, 'Número Viagem')}
                            {getTableLineValue(dados.operacao, 'Operação')}
                            {getTableLineValue(dados.motorista1, 'Motorista 1')}
                            {getTableLineValue(dados.motorista2, 'Motorista 2')}
                            {getTableLineValue(linkGoogle(`${dados.placa} (${dados.tecnologia})`, dados.latitude, dados.longitude), 'Veículo')}
                            {getTableLineValue(linkGoogle(dados.nome_fantasia_transportador, dados.latitude_transportador, dados.longitude_transportador), 'Transportador')}
                            {getTableLineValue(dados.inicio_real, 'Início real')}
                            {getTableLineValue(dados.fim_real, 'Fim real', false)}
                            {getTableLineValue(
                                dados.desvio_rota ? 'Desvio de Rota' : 'Dentro da Rota',
                                'Status da rota',
                                true,
                                estiloDesvio
                            )}
                        </table>
                    </td>
                </tr>
            </table>
        );
    }

    function getDadosOrigem(dados: any) {
        return (
            <table className="tabelaMapa" style={{width: '100%'}}>
                <tr>
                    <td colSpan={2}>
                        <span><img style={{width:'15px', marginRight: '5px'}} src="https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png" alt="Origem" /></span>
                        <strong>DADOS ORIGEM - {linkGoogle(dados.nome_fantasia_origem, dados.latitude_origem, dados.longitude_origem, true)}</strong>
                    </td>
                </tr>
                
                <tr>
                    <td style={{padding: '0 5px 5px 5px'}}>
                        {/* <strong>{dados.nome_fantasia_origem}</strong><br /> */}
                        <table className="table-map" style={{width: '100%'}}>
                            {getTableLinePercentual(dados.porcentagem_percorrida, '% Chegada')}
                            {getTableLineValue(dados.tendencia_atraso_chegada_origem, 'Tendência de atraso chegada origem', true, estiloAtraso)}
                            {getTableLineValue(dados.distancia_total, 'Distancia')}
                            {getTableLineValue(dados.distancia_restante, 'Distancia restante')}
                            {getTableLineValue(dados.saida_para_origem, 'Saída para origem', false, null, true)}
                            {getTableLineValue(dados.tempo_previsto, 'Tempo previsto')}
                            {getTableLineValue(dados.tempo_restante, 'Tempo restante')}
                            {getTableLineValue(dados.chegada_prevista_ajustada, 'Chegada prevista ajustada', true, null, true)}
                            {getTableLineValue(dados.tempo_real, 'Tempo até agora')}
                            {getTableLineValue(dados.carregamento_previsto, 'Previsão chegada', false, null, true)}
                            {getTableLineValue(dados.entrada_raio_origem, 'Chegada real', false, null, true)}
                            {getTableLineValue(dados.tempo_atraso, 'Tempo atraso')}
                            {getTableLineValue(dados.inicio_previsto, 'Previsão início', false, null, true)}
                            {getTableLineValue(dados.saida_raio_origem, 'Saída real', false, null, true)}
                            {getTableLineValue(dados.tempo_permanencia, 'Tempo permanência')}
                            {getTableLineValue(dados.tendencia_de_atraso_permanencia, 'Tendência de atraso permanência', true, estiloAtraso)}
                        </table>
                    </td>
                </tr>
            </table>);
    }

    function getDestinoCard(dados: any, index: any = null, showIndex: boolean = true)
    {
        let destino = dados.destinos[index];
        if (showIndex) {
            return getDadosDestinoFinal(dados, destino[index], true);
        }

        return (
            <div>
                
                <table className="tabelaMapa" style={{width: '90%'}}>
                    <tr>
                        <td colSpan={2}>
                            <strong>{index == null ? '' : `Destino${showIndex ? '' : ` ${index+1}`}:`} {linkGoogle(destino.nome_fantasia, destino.latitude, destino.longitude, true)}</strong><br />
                        </td>
                    </tr>
                    {getTableLinePercentual((destino.chegada_real??'')=='' ? 0 : destino.porcentagem_percorrida, 'Porcentagem')}
                    {getTableLineValue(destino.distancia_tendencia_atraso, 'Tendência de atraso', true, estiloAtraso, true)}
                    {getTableLineValue(destino.distancia_prevista_total, 'Distância')}
                    {getTableLineValue(destino.chegada_prevista, 'Chegada prevista')}
                    {getTableLineValue(destino.chegada_estimada, 'Chegada estimada')}
                    {getTableLineValue(destino.entrada_raio, 'Chegada real')}
                    {getTableLineValue(destino.saida_raio, 'Saída Real')}
                    {/* {getTableLineValue(destino.tempo_previsto_total, 'Tempo Previsto')} */}
                    {getTableLineValue(destino.tempo_permanencia, 'Tempo de permanência')}
                    {getTableLineValue(destino.tendencia_de_atraso_permanencia, 'Tendência de atraso permanência', true, estiloAtraso, true)}
                    {getTableLineValue(destino.tendencia_atraso_permanencia, 'Tendência de atraso permanência')}
                </table>
            </div>);    
    }
    
    function getDadosDestinoFinal(dados: any, destino: any = null, card : boolean = false) {
        // if ((dados.destinos==null || dados.destinos.length <= 1) || (dados.percentual_viagem??'')=='') {
        //     return '';
        // }
        return (
            <table className="tabelaMapa" style={{width: card ? '100%' : '100%'}}>
                <tr>
                    <td colSpan={2}>
                        <span><img style={{width:'15px', marginRight: '5px'}} src="https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png" alt="Origem" /></span>
                        <strong>DADOS DESTINO {(dados?.destinos?.length??1) == 1 ? '' : 'FINAL'} - {linkGoogle(dados.nome_fantasia_destino, dados.latitude_destino, dados.longitude_destino, true)}</strong>
                    </td>
                </tr>
                
                <tr>
                    <td style={{padding: '0 5px 5px 5px'}}>
                    <table style={{width: '100%'}}>
                        {getTableLinePercentual((dados.entrada_raio_destino??'') != '' ? '' : dados.percentual_viagem, '% Percorrida')}
                        {getTableLineValue(dados.tendencia_atraso_chegada_destino, 'Tendência de atraso chegada', true, estiloAtraso)}
                        {getTableLineValue(dados.distancia_total_viagem, 'Distância total')}
                        {getTableLineValue(dados.distancia_percorrida_viagem, 'Distância percorrida')}
                        {/* {getTableLineValue(dados.tempo_total_viagem, 'Tempo total')}
                        {getTableLineValue(dados.tempo_percorrido_viagem, 'Tempo percorrido')} */}
                        {getTableLineValue(dados.chegada_prevista_viagem, 'Chegada prevista')}
                        {getTableLineValue(dados.chegada_estimada_destino, 'Chegada estimada')}
                        {getTableLineValue(dados.entrada_raio_destino, 'Chegada real')}
                        {getTableLineValue(destino?.tempo_permanencia, 'Tempo de permanência')}
                        {getTableLineValue(destino?.tendencia_atraso_permanencia, 'Tendência de atraso permanência')} 
                    </table>
                    </td>
                </tr>
            </table>
        );
    }

    function getCardGenerico(dados: any, titulo: string, descricao: string)
    {
        return (
            <div>
                <table className="tabelaMapa" style={{width: '100%'}}>
                    <tr>
                        <td colSpan={2}>
                            <strong>{titulo}</strong><br />
                        </td>
                    </tr>
                    <tr>
                        <td>Descrição</td><td>{descricao}</td>
                    </tr>
                    <tr>
                        <td>Data/Hora</td><td>{dados.datahoraevento}</td>
                    </tr>
                    <tr>
                        <td>Posição</td><td>{linkGoogle(dados.localizacao, dados.latitude, dados.longitude, true)}</td>
                    </tr>
                </table>
            </div>);    
    }

    function getTableLinePercentual(value: any, label: string) {
        if (value==0 || value == null || value == '') {
            return '';
        }

        return (<tr><td><strong>{label}</strong></td><td><ProgressBarComponent percentual={value} /></td></tr>);
    }

    function getTableLineValue(value: any, label: string, verificarNulo: boolean = true, estilo: any = null, circle:boolean=false)
    {
        if (verificarNulo && (value==0 || value == null || value == '')) {
            return '';
        }

        let styleCircle = '';
        if (circle) {
            styleCircle = ' class="point"';
        }

        if (estilo != null) {
            let color = Object.entries(estilo).find(([key]) => key.toLocaleLowerCase().includes(value.toLocaleLowerCase()))?.[1];
            if (color != null) {
                return parseHtml(`<tr${styleCircle}><td><strong>${label}</strong></td><td class="styleBold" style="font-weight: bold; background-color: ${color}">${value}</td></tr$>`);
            }
        }
        
        return parseHtml(`<tr${styleCircle}><td><strong>${label}</strong></td><td>${value??''}</td></tr$>`);
    }

    function linkGoogle(descricao: any, latitude: any, longitude: any, parse: boolean = false) {
        if (latitude==null || latitude=='' || longitude==null || longitude=='') {
            return descricao;
        }

        if (descricao==null || descricao=='') {
            descricao = `${latitude},${longitude}`;
        }

        let link = (`<a href="https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}" target="_blank">${descricao}</a>`); 
        if (parse) {
            return parseHtml(link);
        }

        return link;
    }
    
    async function enviaMensagem() {
        // if (props.simplePage) {
        //     return;
        // }

        try {

            await confirm({ title: "Deseja realmente reenviar a menagem para os motoristas?" });
            setLoading(true);

            let response: any = await axios.get(`rotograma/enviaMensagem?id=${id}`);
            if (response.error) {
                enqueueSnackbar(response.error, {variant: 'error'});
                return;
            }

            enqueueSnackbar('Enviado com sucesso!');
        }
        catch (err:any) {
            console.error(err);
            enqueueSnackbar('Não enviado!', {variant: 'error'});
            if ((err?.message??'')!='') {
                enqueueSnackbar(err.message, {variant: 'error'});
            }
        }
        finally {
            setLoading(false);
        }
    }

    async function enviaEmail() {
        // if (props.simplePage) {
        //     return;
        // }

        try {
            await confirm({ title: "Deseja realmente reenviar o e-mail para os usuários relacionados?" });
            setLoading(true);

            const response = await axios.get(`/rotograma/buscaDados?viagemId=${relatorio.viagem_id}`);
            const dadosViagem = response.data;            
            if ((dadosViagem?.id??0) == 0) {
                enqueueSnackbar('Viagem não encontrada!', {variant: 'error'});
                return;
            }

            if ((dadosViagem?.enviar_rotograma??0) == 0) {
                enqueueSnackbar('Operação não configurada para envio!', {variant: 'error'});
                return;
            }
    
            await fetch(`https://k1.grupokrona.com.br/jobs/email/emailMensagemRotogramaViagemJob.php?viagem_id=${id}`);

            enqueueSnackbar('Enviado com sucesso!');
        }
        catch (err:any) {
            console.error(err);
            enqueueSnackbar('Não enviado!', {variant: 'error'});
            if (err?.message!=undefined) {
                enqueueSnackbar(err.message, {variant: 'error'});
            }
        }
        finally {
            setLoading(false);
        }
    }

    return (
    <>
        {dados.id==null ? '' : 
        <div className="row" style={{marginRight: '20px', marginTop: '20px'}}>
            {/* <Splitter style={{ height: 200, boxShadow: '0 0 10px rgb(0, 104, 195)' }}>
                <Splitter.Panel defaultSize="40%" min="20%" max="70%">
                <Desc text="First" />
                </Splitter.Panel>
                <Splitter.Panel>
                <Desc text="Second" />
                </Splitter.Panel>
            </Splitter> */}
            
            <div className="col-sm-6 col-12">
                {getDadosViagem(dados)}
                <br />
                {getDadosOrigem(dados)}
                <br />
                {getDadosDestinoFinal(dados)}
                <br />
                {(dados.destinos==null || dados.destinos.length <= 1) || (dados.percentual_viagem??'')=='' ? '' : 
                <table className="tabelaMapa" style={{width: '100%'}}>
                    <tr>
                        <td colSpan={2}>
                            <span><img style={{width:'15px', marginRight: '5px'}} src="https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png" alt="Destino" /></span>
                            <strong>DADOS DESTINOS</strong>
                        </td>
                    </tr>
                    
                    {/* {(dados.destinos==null || dados.destinos.length <= 1) || (dados.percentual_viagem??'')=='' ? '' :
                    <tr>
                        <td colSpan={2} style={{width: '100%', padding: '0 5px 5px 5px'}}>
                            <table style={{width: '100%'}}>
                                <tr>
                                    <td colSpan={2}>
                                    <strong>DESTINO FINAL - {linkGoogle(dados.nome_fantasia_destino, dados.latitude_destino, dados.longitude_destino, true)}</strong>
                                    </td>
                                </tr>
                                {getTableLineValue(dados.distancia_total_viagem, 'Distância total')}
                                {getTableLineValue(dados.distancia_percorrida_viagem, 'Distância percorrida')}
                                {getTableLineValue(dados.tempo_total_viagem, 'Tempo total')}
                                {getTableLineValue(dados.tempo_percorrido_viagem, 'Tempo percorrido')}
                                {getTableLineValue(dados.chegada_prevista_viagem, 'Chegada prevista')}
                                {getTableLineValue(dados.chegada_estimada_destino, 'Chegada estimada destino')}
                                <tr><td><strong>% Percorrida</strong></td><td><ProgressBarComponent percentual={dados.percentual_viagem} /></td></tr>
                                {getTableLineValue(dados.tendencia_atraso_chegada_destino, 'Tendência de atraso chegada', true, estiloAtraso)}
                                {getTableLineValue(dados.chegada_real, 'Chegada real')}
                            </table>
                            
                        </td>
                    </tr>
                    } */}

                    {(dados.destinos==null || dados.destinos.length == 0 ? '' :
                        dados.destinos?.map((destino:any, index:number) => (
                            <tr>
                                <td colSpan={2} style={{padding: '0 5px 5px 5px'}}>{getDestinoCard(dados, index, dados.destinos.length<=1)}</td>
                            </tr>
                        ))
                    )}
                </table>}
                <br />
            </div>

            <div className="col-sm-6 col-12">
                {(marcadores==null || marcadores.length == 0 ? '' : 
                <div>
                    <div>
                        <MapComponent
                            minHeight={600}
                            height={((window.innerHeight) - 190)}
                            marcadores={marcadores}
                            posicoes={posicoes}
                            coordenadas={coordenadas} />
                    </div>
                    {/*  */}
                    <div className="divLegendaMapa row" style={{paddingBottom: '150px'}}>
                        <div className="col-md-3 col-12 row" style={{placeContent: 'space-evenly', marginBottom: '5px'}}>
                            {/* <span className="col-md-12 col-3" style={{color:'#ad9100', padding: 0}}>
                            <span style={{position: 'relative', top: '30px'}}><TruckSvg /></span> Veículo</span> */}
                            <span className="col-md-12 col-3" style={{borderBottom: '4px solid blue', color:'#0000c3', padding: 0}}>Planejado</span>
                            <span className="col-md-12 col-3" style={{borderBottom: '3px dashed red', color:'#d90000',padding: 0}}>Percorrido</span>
                        </div>

                        <label className="col-md-3 col-12">
                            <input type="checkbox" checked={checkboxNaoAutorizada} onChange={(e) => setCheckboxNaoAutorizada(e.target.checked)} />
                            <span className="checkbox-span">
                                <img src="https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png" /> Não Autorizada<br />
                            </span>
                        </label>

                        <label className="col-md-3 col-12">
                            <input type="checkbox" checked={checkboxAreaRisco} onChange={(e) => setCheckboxAreaRisco(e.target.checked)} />
                            <span className="checkbox-span">
                            <span><img src="https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-grey.png" /> Área de Risco<br /></span>
                            </span>
                        </label>
                        
                        <label className="col-md-3 col-12">
                            <input type="checkbox" checked={checkboxMacroAlertaViolacao} onChange={(e) => setCheckboxMacroAlertaViolacao(e.target.checked)} />
                            <span className="checkbox-span">
                            <span><img src="https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-black.png" /> Macro / Alerta / Violação<br /></span>
                            </span>
                        </label>
                    </div>
                </div>
                )}
            </div>
            <div >
                <button className="btn btn-dark" onClick={() => window.open(`/RotogramaViagemPrint/${dados.id}`, '_blank')}>
                    <i className="fa fa-print me-2"></i> Imprimir
                </button>
            </div>
        </div>
        }
        {envioRotogramaOpen ? <EnvioRotogramaViagemPopup viagemId={dados.id} isOpen={envioRotogramaOpen} onClose={() => setEnvioRotogramaOpen(false)} /> : ''}
    </>
    );
}

export default RotogramaViagemComponent;

